import { ReactNode } from "react";

import { StyleProp, View, ViewStyle } from "react-native";
import { useTailwind } from "tailwind-rn";

type Props = {
  children: ReactNode;
  style?: StyleProp<ViewStyle>;
};

export default function Row({ children, style }: Props) {
  const tailwind = useTailwind();
  return (
    <View style={[tailwind("flex-row justify-between"), style]}>
      {children}
    </View>
  );
}
